import { DSDHeader } from "@/components/dsd-view/header";
import { NotFound } from "@/components/common/not-found";
import { useAuth } from "@/contexts/auth-context";
import { FileUploader } from "./admin/file-uploader";
import { SourceTable } from "./admin/source-table";

export const HelpAdminPage: React.FC = () => {
  const { user } = useAuth();

  if (!user?.isAdmin) {
    return <NotFound />;
  }

  return (
    <div className="min-h-screen bg-background-neutral-neutral">
      <DSDHeader />
      <div className="mx-auto max-w-3xl px-5 py-8">
        <h1 className="title-2-bold text-label-normal mb-5">
          사업보고서 자료 업로드
        </h1>
        <FileUploader />
        <h2 className="headline-1-semibold text-label-normal mt-8 mb-4">
          등록된 자료
        </h2>
        <SourceTable />
      </div>
    </div>
  );
};
